/** * 报警记录查看 * 徐杰 * 2019-7-5 **/
<template>
  <div>
    <X-Layout>
      <!-- 头部 -->
      <div class="historyspage" ref="historysPage" :style="{ height: divheight + 'px' }">
        <historyTimeChange
          class="historyear"
          :yearTime="yearName"
          :createTime="createTime"
          @sendChangeTime="changeYear"
        ></historyTimeChange>
        <div class="toptabs">
          <Tabs :active-key="activeKey" @on-click="checkTabs">
            <TabPane label="工况" key="0" icon="icon iconfont icon-gongkuangtu">
              <gongkuangtu
                ref="gongKuang"
                :bodyDivHeight="bodyHeight"
                :yearName="yearName"
                :timesList="timesList"
                @sendBodyHeight="getBodyHeight"
              ></gongkuangtu>
            </TabPane>
            <TabPane label="在线" key="1" icon="icon iconfont icon-yangan">
              <zaixian ref="zaiXian" :bodyDivHeight="bodyHeight" :yearName="yearName" :timesList="timesList"></zaixian>
            </TabPane>
            <TabPane label="油烟" key="2" icon="icon iconfont icon-youyanji">
              <youyan ref="youYan" :bodyDivHeight="bodyHeight" :yearName="yearName" :timesList="timesList"></youyan>
            </TabPane>
          </Tabs>
        </div>
        <!-- 中间 -->
      </div>
    </X-Layout>
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/index.css';
import echarts from 'echarts';
// 工况
import gongkuangtu from './components/gongkuan.vue';
// 油烟
import youyan from './components/youyan.vue';
// 在线
import zaixian from './components/zaixian.vue';
import { mathEleHeight } from '@/utils/common.js';
// 历史年选择
import historyTimeChange from '@/components/historyTimeChange.vue';
export default {
  components: {
    gongkuangtu,
    youyan,
    zaixian,
    historyTimeChange,
  },
  data() {
    return {
      createTime: '', // 公司创建时间
      yearName: '', // 历史在线时间
      divheight: '', //
      bodyHeight: '', // 主框的高度
      treeLoading: false, // 树菜单加载动画
      seachCName: '', // 搜索企业名
      // 时间
      timesList: [
        { label: '最近7天', value: 1 },
        { label: '最近15天', value: 1 },
        { label: '最近1个月', value: 1 },
        { label: '最近3个月', value: 1 },
      ],
      activeKey: '0', // 默认选择工况
      // 【工况信息】
      gkDataInfo: {
        tips: true, // 提示标识
        tipsBtnBG: 'primary', // 按钮样式-表格
        tipsBtnTB: 'default', // 按钮样式-图标
        bgORtb: true, // 表格图标显示
        treeData: [], // 树菜单数据
        treeLoading: false, // 树菜单加载动画
        tbLoading: false, // 表格加载动画
        total: 0, // 共多少条
        page: 1, // 当前多少页
        row: 20, // 每页20条数据
        gkSite_id: '', // 排口id
        defaultProps: {
          // 设置树菜单的接受格式
          children: 'siteid_list',
          label: 'title',
        },
        isZD: true, // 由于记录是否是指定的1,2,3,4,5,6接口  还是按日期范围的接口  true：指定接口  false：日期范围接口
        tableList: [], // 表格数据
        dateBtnType: 1, // 日期按钮记录  1：7天，2：15天，3：1月，4：近2月，5：近6月
        chartLoading: false, // 图表加载动画
        start_date: '', // 日期选择 开始日期
        end_date: '', // 日期选择 结束日期
        echartOption: {
          // 图表格式
          color: ['#c54037'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          xAxis: [
            {
              type: 'category',
              data: ['Mon', 'Tue', 'Wed'],
              axisTick: {
                alignWithLabel: true,
              },
            },
          ],
          yAxis: [
            {
              type: 'value',
            },
          ],
          series: [
            {
              name: '报警次数',
              type: 'bar',
              barWidth: '60%',
              data: [10, 52, 100],
            },
          ],
        },
        columns: [
          // 表格列名
          {
            type: 'index',
            title: '序号',
            align: 'center',
            minWidth: 90,
            indexMethod: row => {
              return row._index + 1 + this.gkDataInfo.page * this.gkDataInfo.row - this.gkDataInfo.row;
            },
          },
          {
            title: '监测名称',
            key: 'cn_name',
            align: 'center',
            minWidth: 200,
          },
          {
            title: '编码',
            key: 'code_name',
            align: 'center',
            minWidth: 100,
          },
          {
            title: '当前值',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              let _class = '';
              switch (
                params.row.status // 判断值 设置对应的样式
              ) {
                case 1:
                  _class = 'demo-table-info-cell-value';
                  break;
                case 2:
                  _class = 'demo-table-info-cell-value';
                  break;
              }
              return h('span', { class: _class }, params.row.value + params.row.unit); // 值+单位
            },
          },
          {
            title: '状态',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              let _status = '';
              let _class = '';
              switch (
                params.row.status // 判断值 设置对应的样式和文字
              ) {
                case 0:
                  _status = '正常';
                  break;
                case 1:
                  _status = '低于标准值';
                  _class = 'demo-table-info-cell-value';
                  break;
                case 2:
                  _status = '高于标准值';
                  _class = 'demo-table-info-cell-value';
                  break;
              }
              return h('span', { class: _class }, _status);
            },
          },
          {
            title: '监测时间',
            align: 'center',
            minWidth: 200,
            render: (h, params) => {
              return h('span', this.formatDateTime(params.row.receive_time)); // 格式时间戳
            },
          },
        ],
      },
      // 【油烟信息】
      yyDataInfo: {
        tips: true, // 提示标识
        tipsBtnBG: 'primary', // 按钮样式-表格
        tipsBtnTB: 'default', // 按钮样式-图标
        bgORtb: true, // 表格图标显示
        treeData: [], // 树菜单数据
        treeLoading: false, // 树菜单加载动画
        tbLoading: false, // 表格加载动画
        total: 0, // 共多少条
        page: 1, // 当前多少页
        row: 20, // 每页20条数据
        yySite_id: '', // 排口id
        defaultProps: {
          // 设置树菜单的接受格式
          children: 'childrens',
          label: 'title',
        },
        isZD: true, // 由于记录是否是指定的1,2,3,4,5,6接口  还是按日期范围的接口  true：指定接口  false：日期范围接口
        tableList: [], // 表格数据
        dateBtnType: 1, // 日期按钮记录  1：7天，2：15天，3：1月，4：近2月，5：近6月
        chartLoading: false, // 图表加载动画
        echartOption: {
          // 图表格式
          color: ['#c54037'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          xAxis: [
            {
              type: 'category',
              data: ['Mon', 'Tue', 'Wed'],
              axisTick: {
                alignWithLabel: true,
              },
            },
          ],
          yAxis: [
            {
              type: 'value',
            },
          ],
          series: [
            {
              name: '报警次数',
              type: 'bar',
              barWidth: '60%',
              data: [10, 52, 100],
            },
          ],
        },
        columns: [
          // 表格列名
          {
            type: 'index',
            title: '序号',
            align: 'center',
            minWidth: 90,
            indexMethod: row => {
              return row._index + 1 + this.yyDataInfo.page * this.yyDataInfo.row - this.yyDataInfo.row;
            },
          },
          {
            title: '监测名称',
            key: 'cn_name',
            align: 'center',
            minWidth: 200,
          },
          {
            title: '编码',
            key: 'code_name',
            align: 'center',
            minWidth: 100,
          },
          {
            title: '当前值',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              let _class = '';
              switch (
                params.row.status // 判断值 设置对应的样式
              ) {
                case 1:
                  _class = 'demo-table-info-cell-value';
                  break;
                case 2:
                  _class = 'demo-table-info-cell-value';
                  break;
              }
              return h('span', { class: _class }, params.row.value + params.row.unit); // 值+单位
            },
          },
          {
            title: '状态',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              let _status = '';
              let _class = '';
              switch (
                params.row.status // 判断值 设置对应的样式和文字
              ) {
                case 0:
                  _status = '正常';
                  break;
                case 1:
                  _status = '低于标准值';
                  _class = 'demo-table-info-cell-value';
                  break;
                case 2:
                  _status = '高于标准值';
                  _class = 'demo-table-info-cell-value';
                  break;
              }
              return h('span', { class: _class }, _status);
            },
          },
          {
            title: '监测时间',
            align: 'center',
            minWidth: 200,
            render: (h, params) => {
              return h('span', this.formatDateTime(params.row.receive_time)); // 格式时间戳
            },
          },
        ],
      },
      // 【在线信息】
      zxDataInfo: {
        tips: true, // 提示标识
        tipsBtnBG: 'primary', // 按钮样式-表格
        tipsBtnTB: 'default', // 按钮样式-图标
        bgORtb: true, // 表格图标显示
        treeData: [], // 树菜单数据
        treeLoading: false, // 树菜单加载动画
        tbLoading: false, // 表格加载动画
        total: 0, // 共多少条
        page: 1, // 当前多少页
        row: 20, // 每页20条数据
        gkSite_id: '', // 排口id
        defaultProps: {
          // 设置树菜单的接受格式
          children: 'siteid_list',
          label: 'title',
        },
        isZD: true, // 由于记录是否是指定的1,2,3,4,5,6接口  还是按日期范围的接口  true：指定接口  false：日期范围接口
        tableList: [], // 表格数据
        dateBtnType: 1, // 日期按钮记录  1：7天，2：15天，3：1月，4：近2月，5：近6月
        chartLoading: false, // 图表加载动画
        start_date: '', // 日期选择 开始日期
        end_date: '', // 日期选择 结束日期
        echartOption: {
          // 图表格式
          color: ['#c54037'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          xAxis: [
            {
              type: 'category',
              data: ['Mon', 'Tue', 'Wed'],
              axisTick: {
                alignWithLabel: true,
              },
            },
          ],
          yAxis: [
            {
              type: 'value',
            },
          ],
          series: [
            {
              name: '报警次数',
              type: 'bar',
              barWidth: '60%',
              data: [10, 52, 100],
            },
          ],
        },
        columns: [
          // 表格列名
          {
            type: 'index',
            title: '序号',
            align: 'center',
            minWidth: 90,
            indexMethod: row => {
              return row._index + 1 + this.zxDataInfo.page * this.zxDataInfo.row - this.zxDataInfo.row;
            },
          },
          {
            title: '监测名称',
            key: 'cn_name',
            align: 'center',
            minWidth: 200,
          },
          {
            title: '编码',
            key: 'code_name',
            align: 'center',
            minWidth: 100,
          },
          {
            title: '当前值',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              let _class = '';
              switch (
                params.row.status // 判断值 设置对应的样式
              ) {
                case 1:
                  _class = 'demo-table-info-cell-value';
                  break;
                case 2:
                  _class = 'demo-table-info-cell-value';
                  break;
              }
              return h('span', { class: _class }, params.row.value + params.row.unit); // 值+单位
            },
          },
          {
            title: '状态',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              let _status = '';
              let _class = '';
              switch (
                params.row.status // 判断值 设置对应的样式和文字
              ) {
                case 0:
                  _status = '正常';
                  break;
                case 1:
                  _status = '低于标准值';
                  _class = 'demo-table-info-cell-value';
                  break;
                case 2:
                  _status = '高于标准值';
                  _class = 'demo-table-info-cell-value';
                  break;
              }
              return h('span', { class: _class }, _status);
            },
          },
          {
            title: '监测时间',
            align: 'center',
            minWidth: 200,
            render: (h, params) => {
              return h('span', this.formatDateTime(params.row.receive_time)); // 格式时间戳
            },
          },
        ],
      },
    };
  },
  destroyed() {
    window.onresize = '';
  },
  mounted() {
    this.$nextTick(() => {
      this.createTime = 2019;
      this.yearName = new Date().getFullYear();
    });
    this.divheight = mathEleHeight(this.$refs.historysPage, 18);
    this.$nextTick(() => {
      window.onresize = () => {
        if (this.$refs.gongKuang && this.$refs.gongKuang.gkChart) {
          this.$refs.gongKuang.gkChart.resize();
        }
        if (this.$refs.youYan && this.$refs.youYan.gkChart) {
          this.$refs.youYan.gkChart.resize();
        }
        if (this.$refs.zaiXian && this.$refs.zaiXian.gkChart) {
          this.$refs.zaiXian.gkChart.resize();
        }
      };
    });
  },
  methods: {
    changeYear(n) {
      this.yearName = n;
    },
    getBodyHeight(n) {
      this.bodyHeight = n;
    },
    // 切换检测项事件 0.工况 1.油烟 2.在线
    checkTabs(e) {
      // if (e == '0' && this.gkDataInfo.treeData.length <= 0) {
      //   this.getGKTreeInfo(); // 初始化 【工况】树菜单
      // } else if (e == '1' && this.yyDataInfo.treeData.length <= 0) {
      //   this.getYYTreeInfo(); // 初始化 【油烟】树菜单
      // } else if (e == '2' && this.zxDataInfo.treeData.length <= 0) {
      //   this.getZXTreeInfo(); // 初始化 【在线】树菜单
      // }
    },
    renderContentGK: function (h, { node, data, store }) {
      switch (
        data.level // 判断树菜单层级
      ) {
        case 1: // 第1层 公司需要显示数量 报警变色
          if (data.warnStatus === 1) {
            // 判断公司报警状态
            return (
              <span style="font-size: 16px;color:red;">
                <i class={data.icon}></i>
                <span style="padding-left: 4px;">{node.label}</span>
                <span>({data.num1})</span>
              </span>
            );
          } else {
            return (
              <span style="font-size: 16px;">
                <i class={data.icon}></i>
                <span style="padding-left: 4px;">{node.label}</span>
              </span>
            );
          }
        case 2: // 第2层 排口不需要显示数量 报警变色
          if (data.status === 1 || data.status === 2) {
            // 判断排口报警状态
            return (
              <span style="font-size: 16px;color:red;">
                <i class={data.icon}></i>
                <span style="padding-left: 4px;">{node.label}</span>
              </span>
            );
          } else {
            return (
              <span style="font-size: 16px;">
                <i class={data.icon}></i>
                <span style="padding-left: 4px;">{node.label}</span>
              </span>
            );
          }
      }
    },
    /**
     * 【在线】树菜单使用的render 使用自定义格式 返回对应的样式
     */
    renderContentZX: function (h, { node, data, store }) {
      switch (
        data.level // 判断树菜单层级
      ) {
        case 1: // 第1层 公司需要显示数量 报警变色
          if (data.warnStatus === 1) {
            // 判断公司报警状态
            return (
              <span style="font-size: 16px;color:red;">
                <i class={data.icon}></i>
                <span style="padding-left: 4px;">{node.label}</span>
                <span>({data.num1})</span>
              </span>
            );
          } else {
            return (
              <span style="font-size: 16px;">
                <i class={data.icon}></i>
                <span style="padding-left: 4px;">{node.label}</span>
              </span>
            );
          }
        case 2: // 第2层 排口不需要显示数量 报警变色
          if (data.status === 1 || data.status === 2) {
            // 判断排口报警状态
            return (
              <span style="font-size: 16px;color:red;">
                <i class={data.icon}></i>
                <span style="padding-left: 4px;">{node.label}</span>
              </span>
            );
          } else {
            return (
              <span style="font-size: 16px;">
                <i class={data.icon}></i>
                <span style="padding-left: 4px;">{node.label}</span>
              </span>
            );
          }
      }
    },
    /**
     * 【工况】渲染树菜单 根据树菜单要求处理传入得到list数据
     */
    handleTreeListGK(list) {
      // 处理得到数据 添加上树菜单需要的字段
      for (let i = 0; i < list.length; i++) {
        // 添加1级数菜单
        list[i].title = list[i].company_name; // 新添title字段 树菜单显示标题
        list[i].icon = 'icon iconfont icon-gongchang'; // 新添icon字段 企业图标
        list[i].level = 1; // 添加层级 当前第1层 用于点击事件判断用
        list[i].keyID = '1' + list[i].company_id; // 添加一个唯一ID 用于展开使用 ；   '1'+ 是为了 1层和2层没有相同的ID

        // 处理2级菜单 判断一下是否有siteid_list节点
        if (list[i].siteid_list) {
          // 循环第二级数据 添加数据
          for (let j = 0; j < list[i].siteid_list.length; j++) {
            list[i].siteid_list[j].title = list[i].siteid_list[j].gkSite_name; // 新添title字段 树菜单显示标题 2级
            list[i].siteid_list[j].icon = 'icon iconfont icon-wuranyuan'; // 新添icon字段 排口图标
            list[i].siteid_list[j].level = 2; // 添加层级 当前第2层 用于点击事件判断用
            list[i].siteid_list[j].keyID = '2' + list[i].siteid_list[j].gkSite_id; // 添加一个唯一ID 用于展开使用 ；  '2'+ 是为了 1层和2层没有相同的ID
          }
        }
      }
      this.gkDataInfo.treeData = list; // 处理好的list赋值树菜单渲染
    },

    /**
     * 【油烟】树菜单使用的render 使用自定义格式 返回对应的样式
     */
    renderContentYY: function (h, { node, data, store }) {
      switch (
        data.level // 判断树菜单层级
      ) {
        case 1: // 第1层 街道显示数量 报警变色
          if (data.streetStatus === 1) {
            return (
              <span style="font-size: 16px;color:red;">
                <i class={data.icon}></i>
                <span style="padding-left: 4px;">{node.label}</span>
                <span>({data.warnCompanyNum})</span>
              </span>
            );
          } else {
            return (
              <span style="font-size: 16px">
                <i class={data.icon}></i>
                <span style="padding-left: 4px;">{node.label}</span>
              </span>
            );
          }
        case 2: // 第2层 公司需要显示数量 报警变色
          if (data.warnStatus === 1) {
            // 判断公司报警状态
            return (
              <span style="font-size: 16px;color:red;">
                <i class={data.icon}></i>
                <span style="padding-left: 4px;">{node.label}</span>
                <span>({data.num1})</span>
              </span>
            );
          } else {
            return (
              <span style="font-size: 16px;">
                <i class={data.icon}></i>
                <span style="padding-left: 4px;">{node.label}</span>
              </span>
            );
          }
        case 3: // 第3层 排口不需要显示数量 报警变色
          if (data.status === 1 || data.status === 2) {
            // 判断排口报警状态
            return (
              <span style="font-size: 16px;color:red;">
                <i class={data.icon}></i>
                <span style="padding-left: 4px;">{node.label}</span>
              </span>
            );
          } else {
            return (
              <span style="font-size: 16px;">
                <i class={data.icon}></i>
                <span style="padding-left: 4px;">{node.label}</span>
              </span>
            );
          }
      }
    },
    /**
     * 【油烟】渲染树菜单 根据树菜单要求处理传入得到list数据
     */

    handleTreeListYY(list) {
      // 处理得到数据 添加上树菜单需要的字段
      for (let i = 0; i < list.length; i++) {
        // 添加1级数菜单 【街道】
        list[i].title = list[i].street_name; // 新添title字段 树菜单显示标题
        list[i].icon = 'icon iconfont icon-quyu'; // 新添icon字段 街道图标
        list[i].level = 1; // 添加层级 当前第1层 用于点击事件判断用
        list[i].keyID = '1' + list[i].street_id; // 添加一个唯一ID 用于展开使用 ；  '1'+ 是为了 1层、2层、3层没有相同的ID
        list[i].childrens = list[i].companylist; // 添加用于树菜单的childrens子级名

        // 处理2级菜单 判断一下是否有childrens节点
        if (list[i].childrens) {
          // 循环第二级数据 添加数据 【公司】
          for (let j = 0; j < list[i].childrens.length; j++) {
            list[i].childrens[j].title = list[i].childrens[j].company_name; // 新添title字段 树菜单显示标题
            list[i].childrens[j].icon = 'icon iconfont icon-jiudian'; // 新添icon字段 企业图标
            list[i].childrens[j].level = 2; // 添加层级 当前第1层 用于点击事件判断用
            list[i].childrens[j].keyID = '2' + list[i].childrens[j].company_id; // 添加一个唯一ID 用于展开使用 ；  '2'+ 是为了  1层、2层、3层没有相同的ID
            list[i].childrens[j].childrens = list[i].childrens[j].siteid_list; // 添加用于树菜单的childrens子级名

            // 处理3级菜单 判断一下是否有childrens节点
            if (list[i].childrens[j].childrens) {
              // 循环第三级数据 添加数据 【排口】
              for (let k = 0; k < list[i].childrens[j].childrens.length; k++) {
                list[i].childrens[j].childrens[k].title = list[i].childrens[j].childrens[k].gkSite_name; // 新添title字段 树菜单显示标题
                list[i].childrens[j].childrens[k].icon = 'icon iconfont icon-youyanji1'; // 新添icon字段 排口图标
                list[i].childrens[j].childrens[k].level = 3; // 添加层级 当前第1层 用于点击事件判断用
                list[i].childrens[j].childrens[k].keyID = '3' + list[i].childrens[j].childrens[k].gkSite_id; // 添加一个唯一ID 用于展开使用；  '3'+ 是为了  1层、2层、3层没有相同的ID
              }
            }
          }
        }
      }
      this.yyDataInfo.treeData = list; // 处理好的list赋值树菜单渲染
    },
    /**
     * 【在线】渲染树菜单 根据树菜单要求处理传入得到list数据
     */

    handleTreeListZX(list) {
      // 处理得到数据 添加上树菜单需要的字段
      for (let i = 0; i < list.length; i++) {
        // 添加1级数菜单
        list[i].title = list[i].company_name; // 新添title字段 树菜单显示标题
        list[i].icon = 'icon iconfont icon-gongchang'; // 新添icon字段 企业图标
        list[i].level = 1; // 添加层级 当前第1层 用于点击事件判断用
        list[i].keyID = '1' + list[i].company_id; // 添加一个唯一ID 用于展开使用 ；   '1'+ 是为了 1层和2层没有相同的ID

        // 处理2级菜单 判断一下是否有siteid_list节点
        if (list[i].siteid_list) {
          // 循环第二级数据 添加数据
          for (let j = 0; j < list[i].siteid_list.length; j++) {
            list[i].siteid_list[j].title = list[i].siteid_list[j].gkSite_name; // 新添title字段 树菜单显示标题 2级
            list[i].siteid_list[j].icon = 'icon iconfont icon-wuranyuan'; // 新添icon字段 排口图标
            list[i].siteid_list[j].level = 2; // 添加层级 当前第2层 用于点击事件判断用
            list[i].siteid_list[j].keyID = '2' + list[i].siteid_list[j].gkSite_id; // 添加一个唯一ID 用于展开使用 ；  '2'+ 是为了 1层和2层没有相同的ID
          }
        }
      }
      this.zxDataInfo.treeData = list; // 处理好的list赋值树菜单渲染
    },
    /**
     * 初始化 【工况】树菜单信息
     */
    getGKTreeInfo(seachName = seachName || '') {
      this.gkDataInfo.total = 0; // 清空
      this.gkDataInfo.page = 1; // 清空
      this.gkDataInfo.row = 20; // 清空
      this.gkDataInfo.tableList = []; // 清空表格
      // 清空图表

      const api = this.ApiUrl + 'company/htAllWarnCompany';
      const data = {
        company_name: seachName,
        type: 0, // 工况
      };
      this.gkDataInfo.treeLoading = true; // 开启加载动画
      // 请求接口
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            this.handleTreeListGK(res.data.extend.pageInfo); // 1.渲染树菜单
          }
          this.gkDataInfo.treeLoading = false; // 开启加载动画
        },
        res => {
          this.gkDataInfo.treeLoading = false; // 开启加载动画
        },
      );
    },
    /**
     * 初始化 【油烟】树菜单信息
     */
    getYYTreeInfo(seachName = seachName || '') {
      this.yyDataInfo.total = 0; // 清空
      this.yyDataInfo.page = 1; // 清空
      this.yyDataInfo.row = 20; // 清空
      this.yyDataInfo.tableList = []; // 清空
      // 清空图表

      const api = this.ApiUrl + 'company/htAllWarnCompany';
      const data = {
        company_name: seachName,
        type: 1, // 油烟
      };
      this.yyDataInfo.treeLoading = true; // 开启加载动画
      // 请求接口
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            this.handleTreeListYY(res.data.extend.pageInfo); // 1.渲染树菜单
          }
          this.yyDataInfo.treeLoading = false; // 开启加载动画
        },
        res => {
          this.yyDataInfo.treeLoading = false; // 开启加载动画
        },
      );
    },
    /**
     * 得到【在线】表格数据
     */
    getZXTabelInfo() {
      let api = null;
      let data = null;
      if (this.zxDataInfo.isZD) {
        // 使用指定的1,2,3,4,5 接口
        api = this.ApiUrl + 'gkData/findDataByTime';
        data = {
          gkSite_id: this.zxDataInfo.gkSite_id,
          page: this.zxDataInfo.page,
          row: this.zxDataInfo.row,
          type: this.zxDataInfo.dateBtnType, // 1：7天，2：15天，3：1月，4：近2月，5：近6月
          types: 2, // 工况
        };
      } else {
        // 使用按时间范围搜索接口
        api = this.ApiUrl + 'gkData/findByStartAndEnd';
        data = {
          start_time: this.zxDataInfo.start_date, // 启始日期
          end_time: this.zxDataInfo.end_date, // 结尾日期
          gkSite_id: this.zxDataInfo.gkSite_id,
          page: this.zxDataInfo.page,
          row: this.zxDataInfo.row,
          type: 2, // 工况
        };
      }

      this.zxDataInfo.tbLoading = true; // 开启加载动画
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            this.zxDataInfo.tableList = res.data.extend.pageInfo.records; // 赋值表格数据
            this.zxDataInfo.total = res.data.extend.pageInfo.total; // 设置总页数
          }

          this.zxDataInfo.tbLoading = false; // 关闭加载动画
        },
        res => {
          this.zxDataInfo.tbLoading = false; // 关闭加载动画
        },
      );
    },
    /**
     * 得到【工况】表格数据
     */
    getGKTabelInfo() {
      let api = null;
      let data = null;
      if (this.gkDataInfo.isZD) {
        // 使用指定的1,2,3,4,5 接口
        api = this.ApiUrl + 'gkData/findDataByTime';
        data = {
          gkSite_id: this.gkDataInfo.gkSite_id,
          page: this.gkDataInfo.page,
          row: this.gkDataInfo.row,
          type: this.gkDataInfo.dateBtnType, // 1：7天，2：15天，3：1月，4：近2月，5：近6月
          types: 0, // 工况
        };
      } else {
        // 使用按时间范围搜索接口
        api = this.ApiUrl + 'gkData/findByStartAndEnd';
        data = {
          start_time: this.gkDataInfo.start_date, // 启始日期
          end_time: this.gkDataInfo.end_date, // 结尾日期
          gkSite_id: this.gkDataInfo.gkSite_id,
          page: this.gkDataInfo.page,
          row: this.gkDataInfo.row,
          type: 0, // 工况
        };
      }

      this.gkDataInfo.tbLoading = true; // 开启加载动画
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            this.gkDataInfo.tableList = res.data.extend.pageInfo.records; // 赋值表格数据
            this.gkDataInfo.total = res.data.extend.pageInfo.total; // 设置总页数
          }

          this.gkDataInfo.tbLoading = false; // 关闭加载动画
        },
        res => {
          this.gkDataInfo.tbLoading = false; // 关闭加载动画
        },
      );
    },
    /**
     * 【工况】图表加载
     */
    getGKChart() {
      var gkChart = echarts.init(this.$refs.gkChart);

      let api = null;
      let data = null;
      if (this.gkDataInfo.isZD) {
        // 使用指定的1,2,3,4,5 接口
        api = this.ApiUrl + 'gkData/countBySiteIdDataByTime';
        data = {
          type: this.gkDataInfo.dateBtnType, // 1：7天，2：15天，3：1月，4：近2月，5：近6月
          gkSite_id: this.gkDataInfo.gkSite_id,
          types: 0, // 工况
        };
      } else {
        // 使用按时间范围搜索接口
        api = this.ApiUrl + 'gkData/countBySiteIdDataStartAndEnd';
        data = {
          start_time: this.gkDataInfo.start_date, // 启始日期
          end_time: this.gkDataInfo.end_date, // 结尾日期
          gkSite_id: this.gkDataInfo.gkSite_id,
          type: 0, // 工况
        };
      }

      this.gkDataInfo.chartLoading = true; // 开启动画
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            var list = res.data.extend;
            this.gkDataInfo.echartOption.xAxis[0].data = list.list1;
            this.gkDataInfo.echartOption.series[0].data = list.list2;
            gkChart.setOption(this.gkDataInfo.echartOption);
            console.log('gkChart', gkChart);
          }
          this.gkDataInfo.chartLoading = false; // 关闭动画
        },
        res => {
          this.gkDataInfo.chartLoading = false; // 关闭动画;
        },
      );
    },
    /**
     * 得到【油烟】表格数据
     */
    getYYTabelInfo() {
      let api = null;
      let data = null;
      if (this.yyDataInfo.isZD) {
        // 使用指定的1,2,3,4,5 接口
        api = this.ApiUrl + 'gkData/findDataByTime';
        data = {
          gkSite_id: this.yyDataInfo.yySite_id,
          page: this.yyDataInfo.page,
          row: this.yyDataInfo.row,
          type: this.yyDataInfo.dateBtnType, // 1：7天，2：15天，3：1月，4：近2月，5：近6月
          types: 1, //  油烟
        };
      } else {
        // 使用按时间范围搜索接口
        api = this.ApiUrl + 'gkData/findByStartAndEnd';
        data = {
          start_time: this.yyDataInfo.start_date, // 启始日期
          end_time: this.yyDataInfo.end_date, // 结尾日期
          gkSite_id: this.yyDataInfo.yySite_id,
          page: this.yyDataInfo.page,
          row: this.yyDataInfo.row,
          type: 1, //  油烟
        };
      }

      this.yyDataInfo.tbLoading = true; // 开启加载动画
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            this.yyDataInfo.tableList = res.data.extend.pageInfo.records; // 赋值表格数据
            this.yyDataInfo.total = res.data.extend.pageInfo.total; // 设置总页数
          }
          this.yyDataInfo.tbLoading = false; // 关闭加载动画
        },
        res => {
          this.yyDataInfo.tbLoading = false; // 关闭加载动画
        },
      );
    },
    /**
     * 【油烟】图表加载
     */
    getYYChart() {
      const yyChart = echarts.init(this.$refs.yyChart);

      let api = null;
      let data = null;
      if (this.yyDataInfo.isZD) {
        // 使用指定的1,2,3,4,5 接口
        api = this.ApiUrl + 'gkData/countBySiteIdDataByTime';
        data = {
          type: this.yyDataInfo.dateBtnType, // 1：7天，2：15天，3：1月，4：近2月，5：近6月
          gkSite_id: this.yyDataInfo.yySite_id,
          types: 1, // 油烟
        };
      } else {
        // 使用按时间范围搜索接口
        api = this.ApiUrl + 'gkData/countBySiteIdDataStartAndEnd';
        data = {
          start_time: this.yyDataInfo.start_date, // 启始日期
          end_time: this.yyDataInfo.end_date, // 结尾日期
          gkSite_id: this.yyDataInfo.yySite_id,
          type: 1, // 油烟
        };
      }

      this.yyDataInfo.chartLoading = true; // 开启动画
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            var list = res.data.extend;
            this.yyDataInfo.echartOption.xAxis[0].data = list.list1;
            this.yyDataInfo.echartOption.series[0].data = list.list2;
            yyChart.setOption(this.yyDataInfo.echartOption);
          }
          this.yyDataInfo.chartLoading = false; // 关闭动画
        },
        res => {
          this.yyDataInfo.chartLoading = false; // 关闭动画;
        },
      );
    },
    /**
     * 【在线】图表加载
     */
    getzxChart() {
      const gkChart = echarts.init(this.$refs.zxChart);

      let api = null;
      let data = null;
      if (this.zxDataInfo.isZD) {
        // 使用指定的1,2,3,4,5 接口
        api = this.ApiUrl + 'gkData/countBySiteIdDataByTime';
        data = {
          type: this.zxDataInfo.dateBtnType, // 1：7天，2：15天，3：1月，4：近2月，5：近6月
          gkSite_id: this.zxDataInfo.gkSite_id,
          types: 2, // 工况
        };
      } else {
        // 使用按时间范围搜索接口
        api = this.ApiUrl + 'gkData/countBySiteIdDataStartAndEnd';
        data = {
          start_time: this.zxDataInfo.start_date, // 启始日期
          end_time: this.zxDataInfo.end_date, // 结尾日期
          gkSite_id: this.zxDataInfo.gkSite_id,
          type: 2, // 工况
        };
      }

      this.zxDataInfo.chartLoading = true; // 开启动画
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            var list = res.data.extend;
            this.zxDataInfo.echartOption.xAxis[0].data = list.list1;
            this.zxDataInfo.echartOption.series[0].data = list.list2;
            gkChart.setOption(this.zxDataInfo.echartOption);
          }
          this.zxDataInfo.chartLoading = false; // 关闭动画
        },
        res => {
          this.zxDataInfo.chartLoading = false; // 关闭动画;
        },
      );
    },
    /**
     * 【在线】树菜单单击事件
     */
    getZXTreeInfo(seachName = seachName || '') {
      this.yyDataInfo.total = 0; // 清空
      this.yyDataInfo.page = 1; // 清空
      this.yyDataInfo.row = 20; // 清空
      this.yyDataInfo.tableList = []; // 清空
      // 清空图表

      const api = this.ApiUrl + 'company/htAllWarnCompany';
      const data = {
        company_name: seachName,
        type: 2, // 在线
      };
      this.zxDataInfo.treeLoading = true; // 开启加载动画
      // 请求接口
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            this.handleTreeListZX(res.data.extend.pageInfo); // 1.渲染树菜单
          }
          this.zxDataInfo.treeLoading = false; // 开启加载动画
        },
        res => {
          this.zxDataInfo.treeLoading = false; // 开启加载动画
        },
      );
    },

    /**
     * 【工况】树菜单单击事件
     */
    handleNodeClickGK(data) {
      // 如果是第2层 就触发 表格事件
      if (data.level === 2) {
        this.gkDataInfo.total = 0; // 清空
        this.gkDataInfo.page = 1; // 初始化 设置第一页
        this.gkDataInfo.row = 20; //  初始化 20条数据
        this.gkDataInfo.tips = false; // 提示标识
        this.gkDataInfo.tableList = [];
        this.gkDataInfo.gkSite_id = data.gkSite_id; // 设置选中排口Id
        this.getGKTabelInfo(); // 执行表格数据
        this.getGKChart(); // 图表
      }
    },
    /**
     * 【油烟】树菜单单击事件
     */
    handleNodeClickYY(data) {
      // 如果是第3层 就触发 表格事件
      if (data.level === 3) {
        this.yyDataInfo.total = 0; // 清空
        this.yyDataInfo.page = 1; // 初始化 设置第一页
        this.yyDataInfo.row = 20; // 初始化 20条数据
        this.yyDataInfo.tips = false; // 提示标识
        this.yyDataInfo.tableList = []; // 数据初始化
        this.yyDataInfo.yySite_id = data.gkSite_id; // 设置选中排口Id
        this.getYYTabelInfo(); // 执行表格数据
        this.getYYChart(); // 图表
      }
    },
    /**
     * 【在线】树菜单单击事件
     */
    handleNodeClickZX(data) {
      console.log('data', data);
      // 如果是第3层 就触发 表格事件
      if (data.level === 2) {
        this.zxDataInfo.total = 0; // 清空
        this.zxDataInfo.page = 1; // 初始化 设置第一页
        this.zxDataInfo.row = 20; // 初始化 20条数据
        this.zxDataInfo.tips = false; // 提示标识
        this.zxDataInfo.tableList = [];
        this.zxDataInfo.gkSite_id = data.gkSite_id; // 设置选中排口Id
        this.getZXTabelInfo(); // 执行表格数据
        this.getzxChart(); // 图表
      }
    },
    // 【工况】切换显示的页数
    onPageSizeGK(e) {
      this.gkDataInfo.row = e;
      this.gkDataInfo.page = 1;
      this.getGKTabelInfo(); // 执行表格数据
    },
    // 【工况】切换下一页
    onNextPageGK(e) {
      this.gkDataInfo.page = e;
      this.getGKTabelInfo(); // 执行表格数据
    },
    // 【油烟】切换显示的页数
    onPageSizeYY(e) {
      this.yyDataInfo.row = e;
      this.yyDataInfo.page = 1;
      this.getYYTabelInfo(); // 执行表格数据
    },
    // 【油烟】切换下一页
    onNextPageYY(e) {
      this.yyDataInfo.page = e;
      this.getYYTabelInfo(); // 执行表格数据
    },
    // 【在线】切换显示的页数
    onPageSizeZY(e) {
      this.zxDataInfo.row = e;
      this.zxDataInfo.page = 1;
      this.getZXTabelInfo(); // 执行表格数据
    },
    // 【在线】切换下一页
    onNextPageZY(e) {
      this.zxDataInfo.page = e;
      this.getZXTabelInfo(); // 执行表格数据
    },

    /**
     * 【工况】表格按钮
     */
    onGKBtnBG() {
      this.gkDataInfo.tipsBtnBG = 'primary'; // 按钮样式-表格
      this.gkDataInfo.tipsBtnTB = 'default'; // 按钮样式-图标
      this.gkDataInfo.bgORtb = true; // 显示表格
      if (gkDataInfo.tableList.length <= 0) {
      }
    },
    /**
     *【工况】图标按钮
     */
    onGKBtnTB() {
      this.gkDataInfo.tipsBtnBG = 'default'; // 按钮样式-表格
      this.gkDataInfo.tipsBtnTB = 'primary'; // 按钮样式-图标
      this.gkDataInfo.bgORtb = false; // 显示图表
    },
    /**
     * 【油烟】表格按钮
     */
    onYYBtnBG() {
      this.yyDataInfo.tipsBtnBG = 'primary'; // 按钮样式-表格
      this.yyDataInfo.tipsBtnTB = 'default'; // 按钮样式-图标
      this.yyDataInfo.bgORtb = true; // 显示表格
    },
    /**
     *【油烟】图标按钮
     */
    onYYBtnTB() {
      this.yyDataInfo.tipsBtnBG = 'default'; // 按钮样式-表格
      this.yyDataInfo.tipsBtnTB = 'primary'; // 按钮样式-图标
      this.yyDataInfo.bgORtb = false; // 显示图表
    },
    /**
     * 【在线】表格按钮
     */
    onZXBtnBG() {
      this.zxDataInfo.tipsBtnBG = 'primary'; // 按钮样式-表格
      this.zxDataInfo.tipsBtnTB = 'default'; // 按钮样式-图标
      this.zxDataInfo.bgORtb = true; // 显示表格
    },
    /**
     *【在线】图标按钮
     */
    onZXBtnTB() {
      this.zxDataInfo.tipsBtnBG = 'default'; // 按钮样式-表格
      this.zxDataInfo.tipsBtnTB = 'primary'; // 按钮样式-图标
      this.zxDataInfo.bgORtb = false; // 显示图表
    },
    /**
     * 【工况】日期按钮事件
     */
    onGKBtnDate(type, eveDate) {
      this.gkDataInfo.total = 0; // 清空
      this.gkDataInfo.page = 1; // 初始化 设置第一页
      this.gkDataInfo.row = 20; // 初始化 20条数据

      this.gkDataInfo.dateBtnType = type;
      // 判断使用 是否从日期控件点击进来
      if (type === 6) {
        this.gkDataInfo.isZD = false;
        this.gkDataInfo.start_date = eveDate[0]; // 得到开始日期
        this.gkDataInfo.end_date = eveDate[1]; // 得到结束日期
      } else {
        this.gkDataInfo.isZD = true; // 指定的1,2,3,4,5,6接口
      }
      // 判断排口id是否存在 如果不存在 代表没有点击左菜单
      if (this.gkDataInfo.gkSite_id) {
        // 表格被选中

        this.getGKTabelInfo(); // 调用表格

        this.getGKChart(); // 图表
      }
    },
    /**
     * 【油烟】日期按钮事件
     */
    onYYBtnDate(type, eveDate) {
      this.yyDataInfo.total = 0; // 清空
      this.yyDataInfo.page = 1; // 初始化 设置第一页
      this.yyDataInfo.row = 20; // 初始化 20条数据

      this.yyDataInfo.dateBtnType = type;
      // 判断使用 是否从日期控件点击进来
      if (type === 6) {
        this.yyDataInfo.isZD = false;
        this.yyDataInfo.start_date = eveDate[0]; // 得到开始日期
        this.yyDataInfo.end_date = eveDate[1]; // 得到结束日期
      } else {
        this.yyDataInfo.isZD = true; // 指定的1,2,3,4,5,6接口
      }
      if (this.yyDataInfo.yySite_id) {
        this.getYYTabelInfo(); // 调用表格
        this.getYYChart(); // 图表
      }
    },
    /**
     * 【油烟】日期按钮事件
     */
    onZXBtnDate(type, eveDate) {
      this.zxDataInfo.total = 0; // 清空
      this.zxDataInfo.page = 1; // 初始化 设置第一页
      this.zxDataInfo.row = 20; // 初始化 20条数据

      this.zxDataInfo.dateBtnType = type;
      // 判断使用 是否从日期控件点击进来
      if (type === 6) {
        this.zxDataInfo.isZD = false;
        this.zxDataInfo.start_date = eveDate[0]; // 得到开始日期
        this.zxDataInfo.end_date = eveDate[1]; // 得到结束日期
      } else {
        this.zxDataInfo.isZD = true; // 指定的1,2,3,4,5,6接口
      }
      if (this.zxDataInfo.gkSite_id) {
        this.getZXTabelInfo(); // 调用表格
        this.getzxChart(); // 图表
      }
    },
    // 刷新页面
    reload() {
      location.reload();
    },
  },
};
</script>
<style lang="scss">
.historyspage {
  .ivu-tabs-nav {
    margin-left: 170px;
  }
  .ivu-table td,
  .ivu-table th {
    border-bottom: none;
  }
  .demo-table-info-cell-value {
    white-space: nowrap;
  }
  .ivu-tabs-bar {
    margin-bottom: 0px;
  }
  .ivu-tabs-nav-scroll {
    background-color: #fff;
    padding-left: 5px;
  }

  .ivu-tabs-nav .ivu-tabs-tab {
    color: #5f788e;
  }
  .ivu-tabs-nav .ivu-tabs-tab-active {
    color: #2d8cf0;
  }
  .el-tree-node__content {
    color: #5f788e;
    height: 27px;
  }
  .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #d9e7ff !important;
  }
  .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    color: #0062ff !important;
    font-weight: bold;
  }

  .gongkuanpage {
    .ivu-table-cell {
      color: #5f788e;
      font-weight: 400;
    }
  }
}
</style>
<style scoped lang="scss">
.historyspage {
  overflow: hidden;
  font-family: PingFang SC;
  position: relative;
  .historyear {
    position: absolute;
    top: 2px;
    left: 5px;
    z-index: 10;
  }
  .toptabs {
    // background-color: #fff;
    // padding-left: 5px;
  }
}
.ivu-table {
  font-size: 14px;
}
.topbtn {
  display: flex;
  justify-content: space-between;
}
.bgAtb {
  min-width: 165px;
}
.tips {
  width: 0px;
  height: 0px;
  position: absolute;
  top: 10px;
  left: -110px;
  width: 300px;
  z-index: 9;
}
.tips span {
  position: relative;
  top: -30px;
  left: 12px;
}
.divday {
  margin-top: 2px;
}

.divday > button {
  margin-right: 5px;
}

.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  font-size: 1.5rem;
}

.refresh {
  float: right;
  margin-right: 1.25rem;
}

.optdiv {
  display: flex;
  padding: 0.625rem 0;
  justify-content: space-between;
}

.tabdiv {
  margin-bottom: 20px;
  width: 80%;
}

.comname {
  padding: 10px 0;
  display: block;
  color: #cccccc;
}

.chart {
  width: 800px;
  height: 400px;
}
</style>
